import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {FlowModule} from '@fantasmagames/slot/src/modules/flow/FlowModule';
import {QueueEventsHandler} from '@fantasmagames/slot/src/modules/flow/states/QueueEventsHandler';
import {IEventManagerWithAsync} from '@fantasmagames/core/src/events/_interfaces/IEventManager';
import {LogicEvents} from '@fantasmagames/slot/src/logic/LogicEvents';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';

export class FlowWhileSpinningState extends ModuleState<null, FlowModule> {
	protected _queueEvents: QueueEventsHandler;

	constructor(module: FlowModule, name: string, eventManager: IEventManagerWithAsync) {
		super(module, name);
		this._queueEvents = new QueueEventsHandler(eventManager);
	}

	public onEnterState(): void {
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {
		this.on(LogicEvents.SPIN_RESPONSE, this.onSpinResponse);
	}

	protected onSpinResponse(): void {
		this.continueToGameplay();
	}

	protected continueToGameplay(): void {
		this.emitDelayed(FlowModuleEvents.CAN_CONTINUE_SPIN);
		this.module.gotoPreviousState();
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/flow/states/FlowWhileSpinningState.ts